<template>
  <div class="flower-editor-page">
    <div v-if="!isEditing" class="editor-mode-switch">
      <span class="editor-mode-label">类型</span>
      <el-radio-group v-model="mode" size="small" @change="changeMode">
        <el-radio-button label="texture">贴图</el-radio-button>
        <el-radio-button label="glb">GLB</el-radio-button>
      </el-radio-group>
    </div>
    <glb-editor :mode="mode" />
  </div>
</template>

<script>
import GlbEditor from "./glbUpload.vue";

export default {
  name: "FlowerEditor",
  components: { GlbEditor },
  data() {
    return { mode: this.$route.query.mode === "glb" ? "glb" : "texture" };
  },
  computed: {
    isEditing() {
      return !!this.$route.query.id;
    },
  },
  methods: {
    changeMode(mode) {
      this.mode = mode;
      this.$router.replace({
        path: this.$route.path,
        query: { ...this.$route.query, mode },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.flower-editor-page {
  min-height: 100%;
  padding-bottom: 24px;
}

.editor-mode-switch {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
}

.editor-mode-label {
  color: #606266;
  font-size: 14px;
}

</style>
